import React, { useState, useEffect } from "react";
import { useOrderContext, useAppContext } from "../../contexts";
import { useDispatch, useSelector } from "react-redux";
import {
  updateSelectedProductDetails,
  setProductDetails,
} from "../../redux/slices";
import {
  selectedProductActionTypes,
  productActionTypes,
} from "../../redux/utils";
import { CURRENCY_SYMBOLS } from "../../Utilities/currency";
import { IoAlertCircleOutline } from "react-icons/io5";

export const ProductCard = ({
  orderInfo,
  setIsSelected,
  setOrderInfo,
  setVariantID,
  setIsBtnDisabled,
}) => {

  const [showQty, setShowQty] = useState(false);
  const [rangeListForQuantityOptions, setRangeListForQuantityOptions] =
    useState([]);
  const dispatch = useDispatch();
  const { selectReturnItem, setSelectReturnItem } = useOrderContext();
  const { setRazorPayPaymentSuccess, setIsPaymentCompleted } = useAppContext();
  const productDetailsState = useSelector((state) => state.productDetails);
  const storeConfigState = useSelector((state) => state.storeSettings);
  const selectedProductDetailsState = useSelector(
    (state) => state.selectedProductDetails
  );
  /* setting the default value for selected product */
  const selectItemHandler = (item) => {
    dispatch(
      setProductDetails({
        key: productActionTypes.SET_RETURN_REASON,
        value: item.line_item_return_reason,
      })
    );

    dispatch(
      updateSelectedProductDetails({
        key: selectedProductActionTypes.SET_VARIANT_ID,
        value: item.variant_id,
      })
    );

    dispatch(
      updateSelectedProductDetails({
        key: selectedProductActionTypes.SET_PRODUCT_ID,
        value: item.product_id,
      })
    );

    dispatch(
      updateSelectedProductDetails({
        key: selectedProductActionTypes.SET_ITEM_EXCHANGE_ALLOWED,
        value: item.exchange_allowed,
      })
    );

    dispatch(
      updateSelectedProductDetails({
        key: selectedProductActionTypes.SET_RETURN_ALLOWED,
        value: item.return_allowed,
      })
    );

    dispatch(
      updateSelectedProductDetails({
        key: selectedProductActionTypes.SET_SELECTED_PRODUCT_IMAGE,
        value: item.product_image,
      })
    );

    dispatch(
      updateSelectedProductDetails({
        key: selectedProductActionTypes.SET_SELECTED_PRODUCT_PRICE,
        value: item.price,
      })
    );

    dispatch(
      updateSelectedProductDetails({
        key: selectedProductActionTypes.SET_LINE_ITEM_ID,
        value: item.line_item_id,
      })
    );

    dispatch(
      updateSelectedProductDetails({
        key: selectedProductActionTypes.SET_LINE_ITEM_LOCATION_ID,
        value: item.line_item_location_id,
      })
    );

    dispatch(
      updateSelectedProductDetails({
        key: selectedProductActionTypes.SET_COUNTRY_CODE,
        value: item.country_code,
      })
    );

    dispatch(
      updateSelectedProductDetails({
        key: selectedProductActionTypes.SET_STORE_CREDIT_APPLICABLE,
        value: item.store_credit_applicable,
      })
    );

    dispatch(
      updateSelectedProductDetails({
        key: selectedProductActionTypes.SET_ORIGINAL_PAYMENT_APPLICABLE,
        value: item.original_payment_applicable,
      })
    );

    //If item.quantity>1
    if (item.quantity > 1) {
      generateQuantityOptions(item?.quantity);
      setShowQty(true);
    } else {
      generateQuantityOptions(1);
      setShowQty(false);
    }

    //On card select set item quantity to 1
    dispatch(
      updateSelectedProductDetails({
        key: selectedProductActionTypes.SET_SELECTED_ITEM_QUANTITY,
        value: "1",
      })
    );

    dispatch(
      updateSelectedProductDetails({
        key: selectedProductActionTypes.UPDATE_CONFIGURED_POLICY_VIOLATED_MESSAGE,
        value: item.configured_policy_violated_message
      })
    );

    setVariantID(item.variant_id);

    /* Continue button enable/disable */
    if (
      (
        !productDetailsState.isPolicyOverwritten &&
        !item.exchange_allowed &&
        !item.return_allowed
      ) || item?.payment_verification_in_progress
    )  {
      setIsBtnDisabled(true);
    } else {
      setSelectReturnItem(item.line_item_id);
      setIsBtnDisabled(false);
    }
  };

  const generateQuantityOptions = (quantity) => {
    let quantityOptions = [];
    for (let i = 1; i <= quantity; i++) {
      quantityOptions.push(i);
    }

    setRangeListForQuantityOptions(quantityOptions);
  };

  const handleSelectQuantity = (event) => {
    dispatch(
      updateSelectedProductDetails({
        key: selectedProductActionTypes.SET_SELECTED_ITEM_QUANTITY,
        value: event.target.value,
      })
    );
  };

  /*Setting the selected value */
  useEffect(() => {
    selectReturnItem ? setIsSelected(true) : setIsSelected(false);
    setRazorPayPaymentSuccess(false);
    setIsPaymentCompleted(false);
  }, [selectReturnItem]);

  /*Setting the order info */
  useEffect(() => {
    setOrderInfo(productDetailsState.getRefund);
    dispatch(
      setProductDetails({
        key: productActionTypes.SET_RETURN_REASON,
        value: null,
      })
    );
    
    if (orderInfo?.length === 1) {
      selectItemHandler(orderInfo[0]);
    }
  }, []);
  return (
    <>
      <div className="product-card-container">
        {orderInfo?.map((item, index) => (
          <label
            key={item.variant_id}
            htmlFor={`productCard${index}`}
            className={` product-card ${
              selectReturnItem === item.line_item_id && "product_card_active"
            } `}
          >
            <div className="product-image">
              <input
                type="radio"
                name="product"
                className="productCard"
                checked={selectReturnItem === item.line_item_id}
                id={`productCard${index}`}
                onClick={(e) => {
                  selectItemHandler(item);
                }}
              />
              <img src={item.product_image} alt={item.product_name} />
            </div>

            <div className="product-details">
              <div className="product-name-variant">
                <h3>{item.product_name}</h3>
                {/* <h4>{item.product_name.split("-")[1]}</h4> */}
                {!productDetailsState.isPolicyOverwritten &&
                  !item.exchange_allowed &&
                  !item.return_allowed && (
                    <span className="info__error error-items">
                      {storeConfigState?.themeConfig?.return_policy_url ? (
                        <a
                          className="info__error_policy"
                          href={
                            storeConfigState?.themeConfig?.return_policy_url
                          }
                          target="_blank"
                          rel="noreferrer"
                        >
                          {
                            item?.configured_policy_violated_message || storeConfigState?.themeConfig?.errors_violated_policy
                          }
                        </a>
                      ) : (
                        item?.configured_policy_violated_message || storeConfigState?.themeConfig?.errors_violated_policy
                      )}
                    </span>
                  )}
              </div>
              <div className="product-price-qty">
                <p>
                  {CURRENCY_SYMBOLS[item.currency]}
                  {item.price}
                </p>
                {rangeListForQuantityOptions && (
                  <div
                    className="card__select"
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                  >
                    {showQty && selectReturnItem === item.line_item_id && (
                      <select
                        className="card__select__container"
                        onChange={(e) => {
                          handleSelectQuantity(e);
                          e.stopPropagation();
                        }}
                      >
                        {rangeListForQuantityOptions.map((quantity, key) => {
                          return (
                            <option
                              key={key}
                              className="card__select__container__item"
                              defaultValue={quantity}
                              selected={
                                parseInt(
                                  selectedProductDetailsState.selectedQuantity
                                ) === quantity
                              }
                            >
                              {quantity}
                            </option>
                          );
                        })}
                      </select>
                    )}
                  </div>
                )}
              </div>
            </div>
            {
              item?.payment_verification_in_progress &&
              <div className="info__payment-items">
                <span>
                  <IoAlertCircleOutline />
                </span>
                <p>{storeConfigState?.themeConfig?.payment_verification_in_progress || "Your payment for a previous return/exchange request is still being processed. Please wait at least 30 minutes from your last request before submitting a new one."}</p>
              </div>
            }
          </label>
        ))}
      </div>
    </>
  );
};
